import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { addVideo, updateVideo, fetchVideo } from "../../Slices/youtubeVideo.slice";
import { addTrek } from "../../Slices/trek.slice";
import ImageUploader from "components/shared/ImageUploader";
import { ImageUploadForm } from "./uploadImages";
import { ImageSelector } from "./ImageSelector";
import { MdDelete } from "react-icons/md";

export const AddVideo = ({ setShowForm, editFormData }) => {
    const [formData, setFormData] = useState({
        category: "",
        location: "",
        videoLink: ""
    });

    const dispatch = useDispatch();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (editFormData) {
            dispatch(updateVideo({ ...editFormData, ...formData }));
            dispatch(fetchVideo());
        } else {
            dispatch(addVideo(formData));
        }
        setShowForm(false);

    }
    useEffect(() => {
        if (editFormData) {
            setFormData({
                category: editFormData.category || "",
                location: editFormData.location || "",
                videoLink: editFormData.videoLink || "",
            });
        } else {
            setFormData({
                category: "",
                locationName: "",
                videoLink: "",
            });
        }
    }, [editFormData]);


    return (
        <>
            <form id="addLocation" onSubmit={handleSubmit}>
                <div className="inputWrapper p-2">
                    <label htmlFor="category">Category</label>
                    <select
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                        id=""
                        className="inputWrapper p-2"
                    >
                        <option value="" disabled>Select a category</option>
                        <option value="trek">trek</option>
                        <option value="tour">tour</option>
                        <option value="travel">travel</option>
                    </select>
                </div>
                <div className="inputWrapper p-2">
                    <label htmlFor="locationName">Location Name</label>
                    <input
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="location Name"
                    />
                </div>
                <div className="inputWrapper p-2">
                    <label htmlFor="videoLink">Video link</label>
                    <input
                        name="videoLink"
                        value={formData.videoLink}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="youtube video link"
                    />
                </div>
                <div className="inputWrapper p-2">
                    <button type="submit">Add Video</button>
                </div>
            </form>
        </>
    )
}

export const AddEvent = ({ formData, setFormData, onSubmit, isEditing }) => {
    const defaultEventCategory = "upcoming events";

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const keys = name.split(".");

        setFormData((prevState) => {
            let updatedState = { ...prevState };
            let nestedState = updatedState;

            for (let i = 0; i < keys.length - 1; i++) {
                if (!nestedState[keys[i]]) nestedState[keys[i]] = {};
                nestedState = nestedState[keys[i]];
            }

            nestedState[keys[keys.length - 1]] = value;
            return { ...updatedState };
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        const formattedData = {
            ...formData,
            category: defaultEventCategory,
            contact: formData.contact ? parseInt(formData.contact, 10) : 0,
            aboutORG: {
                ...formData.aboutORG,
                totalTrips: formData.aboutORG.totalTrips ? parseInt(formData.aboutORG.totalTrips, 10) : 0,
            },
            features: {
                ...formData.features,
                days: formData.features.days ? parseInt(formData.features.days, 10) : 0,
            },
        };

        const formDataToSend = new FormData();
        formDataToSend.append("eventData", JSON.stringify(formattedData));

        if (formData.poster.file) {
            formDataToSend.append("poster", formData.poster.file);
        }

        if (onSubmit) {
            onSubmit(formDataToSend);
        }
    };



    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="inputWrapper col-4 p-2">
                    <label>Event Name</label>
                    <input
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="Event Name"
                        required
                    />
                </div>
                <div className="inputWrapper col-4 p-2">
                    <label>Select Poster</label>
                    <input
                        name="poster.img"
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    poster: {
                                        ...prevState.poster,
                                        file,
                                        img: URL.createObjectURL(file) // Preview Image
                                    },
                                }));
                            }
                        }}
                    />

                </div>
                <div className="inputWrapper col-4 p-2">
                    <label>Poster Alt Text</label>
                    <input
                        name="poster.alt"
                        value={formData.poster.alt}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="Poster Alt Text"
                    />
                </div>
            </div>

            <div className="row">
                <div className="inputWrapper col-4 p-2">
                    <label>Contact</label>
                    <input
                        name="contact"
                        value={formData.contact}
                        onChange={handleInputChange}
                        type="number"
                        placeholder="Contact Number"
                        required
                    />
                </div>
                <div className="inputWrapper col-4 p-2">
                    <label>Category</label>
                    <input
                        name="category"
                        value="Upcoming Events"
                        readOnly
                        type="text"
                        className="p-2"
                    />
                </div>
                <div className="inputWrapper col-4 p-2">
                    <label>Amount to Pay</label>
                    <input
                        name="amountToPay"
                        value={formData.amountToPay}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value) && value >= 0) {
                                setFormData({
                                    ...formData,
                                    amountToPay: value,
                                });
                            }
                        }}
                        type="number"
                        placeholder="Amount to Pay"
                        min="0"
                    />
                </div>
            </div>

            <fieldset>
                <legend>About Organization</legend>
                <div className="row">
                    <div className="inputWrapper col-4 p-2">
                        <label>Organization Name</label>
                        <input
                            name="aboutORG.oraganization"
                            value={formData.aboutORG.oraganization}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Organization Name"
                            required
                        />
                    </div>

                    <div className="inputWrapper col-4 p-2">
                        <label>Member Since</label>
                        <input
                            name="aboutORG.memberSince"
                            value={formData.aboutORG.memberSince}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="2014"
                        />
                    </div>
                    <div className="inputWrapper col-4 p-2">
                        <label>Total Trips</label>
                        <input
                            name="aboutORG.totalTrips"
                            value={formData.aboutORG.totalTrips}
                            onChange={handleInputChange}
                            type="number"
                            placeholder="Total Trips in Number"
                        />
                    </div>

                </div>
                <div className="row">
                    <div className="inputWrapper col-4 p-2">
                        <label>Instagram Link</label>
                        <input
                            name="aboutORG.socialLinks.insta"
                            value={formData.aboutORG.socialLinks.insta}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Instagram Link"
                        />
                    </div>

                    <div className="inputWrapper col-4 p-2">

                        <label>Facebook Link</label>
                        <input
                            name="aboutORG.socialLinks.fb"
                            value={formData.aboutORG.socialLinks.fb}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Facebook Link"
                        />
                    </div>
                </div>

            </fieldset>

            <fieldset>
                <legend>Features</legend>
                <div className="row">
                    <div className="inputWrapper col-4 p-2">
                        <label>Days</label>
                        <input
                            name="features.days"
                            value={formData.features.days}
                            onChange={handleInputChange}
                            type="number"
                            placeholder="Number of Days"
                        />
                    </div>
                    <div className="inputWrapper col-4 p-2">
                        <label>Approximate Distance</label>
                        <input
                            name="features.approxDistance"
                            value={formData.features.approxDistance}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="e.g. 50 km"
                        />
                    </div>
                    <div className="inputWrapper col-4 p-2">
                        <label>Starting Date</label>
                        <input
                            name="features.startingDate"
                            value={formData.features.startingDate}
                            onChange={handleInputChange}
                            type="date"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="inputWrapper col-4 p-2">
                        <label>Starts From</label>
                        <input
                            name="features.startsFrom"
                            value={formData.features.startsFrom}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Starting Location"
                        />
                    </div>
                    <div className="inputWrapper col-4 p-2">
                        <label>Altitude</label>
                        <input
                            name="features.altitude"
                            value={formData.features.altitude}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Altitude (e.g., 5000 ft)"
                        />
                    </div>
                    <div className="inputWrapper col-4 p-2">
                        <label>Grade</label>
                        <select
                            name="features.grade"
                            value={formData.features.grade}
                            onChange={handleInputChange}
                            className="p-2"
                        >
                            <option value="">Select Grade</option>
                            <option value="Easy">Easy</option>
                            <option value="Moderate">Moderate</option>
                            <option value="Difficult">Difficult</option>
                            <option value="Extreme">Extreme</option>
                        </select>
                    </div>

                </div>
            </fieldset>
            <div className="inputWrapper col-8 p-2">
                <label>Event Description</label>
                <textarea
                    name="desc"
                    value={formData.desc}
                    onChange={handleInputChange}
                    placeholder="Provide a brief description of the event"
                    rows="4"
                    style={{ width: "40rem" }}
                />
            </div>
            <div className="inputWrapper p-2">
                <button type="submit">Add Event</button>
            </div>
        </form>
    );
};

export const AddLocalGuide = ({ location, onSubmit }) => {
    const [localGuides, setLocalGuides] = useState(
        location.localGuides || [
            {
                name: "",
                location: "",
                providingServices: "",
                languages: [], // ✅ Now an array to allow multiple selections
                experience: "",
                hotelImages: [], // ✅ Array for multiple images
            },
        ]
    );

    // ✅ Handle text input change
    const handleChange = (index, e) => {
        const { name, value } = e.target;
        const updatedGuides = [...localGuides];
        updatedGuides[index][name] = value;
        setLocalGuides(updatedGuides);
    };

    // ✅ Handle language checkbox change
    const handleLanguageChange = (index, e) => {
        const { value, checked } = e.target;
        setLocalGuides((prevGuides) =>
            prevGuides.map((guide, i) => {
                if (i === index) {
                    let languages = guide.languages || [];
                    if (checked) {
                        if (!languages.includes(value)) {
                            languages = [...languages, value];
                        }
                    } else {
                        languages = languages.filter((lang) => lang !== value);
                    }
                    return { ...guide, languages };
                }
                return guide;
            })
        );
    };

    const handleImageSelection = (index, image) => {
        setLocalGuides((prevGuides) =>
            prevGuides.map((guide, i) =>
                i === index
                    ? { ...guide, hotelImages: [...guide.hotelImages, image] } // ✅ Create a new object
                    : guide
            )
        );
    };

    // ✅ Handle Removing a Specific Image
    const handleRemoveImage = (guideIndex, imgIndex) => {
        setLocalGuides((prevGuides) =>
            prevGuides.map((guide, i) =>
                i === guideIndex
                    ? {
                        ...guide,
                        hotelImages: guide.hotelImages.filter((_, j) => j !== imgIndex),
                    } // ✅ Create new object & new array
                    : guide
            )
        );
    };

    // ✅ Handle Adding a New Guide
    const addGuide = () => {
        setLocalGuides([
            ...localGuides,
            {
                name: "",
                location: "",
                providingServices: "",
                languages: [],
                experience: "",
                hotelImages: [], // ✅ Initialize empty for new guide
            },
        ]);
    };

    // ✅ Handle Removing a Guide
    const removeGuide = (index) => {
        setLocalGuides(localGuides.filter((_, i) => i !== index));
    };

    // ✅ Handle Form Submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ localGuides });
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: "100%", margin: "auto", padding: "30px" }}>
            <h3>Add Local Guides</h3>

            {localGuides.map((guide, index) => (
                <div key={index} style={styles.card}>
                    <div className="row">
                        <div className="inputWrapper col-3 p-2">
                            <label>Guide Name</label>
                            <input
                                name="name"
                                value={guide.name}
                                onChange={(e) => handleChange(index, e)}
                                type="text"
                                placeholder="Guide Name"
                                required
                            />
                        </div>
                        <div className="inputWrapper col-3 p-2">
                            <label>Location</label>
                            <input
                                name="location"
                                value={guide.location}
                                onChange={(e) => handleChange(index, e)}
                                type="text"
                                placeholder="Location"
                            />
                        </div>
                        <div className="inputWrapper col-3 p-2">
                            <label>Providing Services</label>
                            <input
                                name="providingServices"
                                value={guide.providingServices}
                                onChange={(e) => handleChange(index, e)}
                                type="text"
                                placeholder="Food, Guide, Accommodation... etc."
                            />
                        </div>
                        <div className="inputWrapper col-3 p-2">
                            <label>Experience (Years)</label>
                            <input
                                name="experience"
                                value={guide.experience}
                                onChange={(e) => handleChange(index, e)}
                                type="text"
                                placeholder="3+"
                            />
                        </div>
                    </div>

                    {/* ✅ Languages Checkboxes */}
                    <div className="row">
                        <div className="inputWrapper col-3 p-2">
                            <label>Languages</label>
                            <div>
                                <label>
                                    <input
                                        type="checkbox"
                                        name="languages"
                                        value="English"
                                        checked={guide.languages.includes("English")}
                                        onChange={(e) => handleLanguageChange(index, e)}
                                    />
                                    English
                                </label>
                                <label style={{ marginLeft: "10px" }}>
                                    <input
                                        type="checkbox"
                                        name="languages"
                                        value="Hindi"
                                        checked={guide.languages.includes("Hindi")}
                                        onChange={(e) => handleLanguageChange(index, e)}
                                    />
                                    Hindi
                                </label>
                                <label style={{ marginLeft: "10px" }}>
                                    <input
                                        type="checkbox"
                                        name="languages"
                                        value="Marathi"
                                        checked={guide.languages.includes("Marathi")}
                                        onChange={(e) => handleLanguageChange(index, e)}
                                    />
                                    Marathi
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* ✅ Image Upload Section */}
                    <div className="inputWrapper col-6 p-2">
                        <label>Hotel Images</label>
                        <ImageSelector
                            selectedImage={null}
                            handleImageSelection={(image) => handleImageSelection(index, image)}
                        />
                    </div>

                    {/* ✅ Display Selected Images */}
                    {guide.hotelImages.length > 0 && (
                        <div style={styles.gridContainer}>
                            {guide.hotelImages.map((image, imgIndex) => (
                                <div key={imgIndex} style={styles.imageWrapper}>
                                    <img
                                        src={image.compressedFilePath}
                                        alt={`Hotel ${imgIndex}`}
                                        style={styles.thumbnail}
                                    />
                                    <button onClick={() => handleRemoveImage(index, imgIndex)} style={styles.deleteButton}>
                                        <MdDelete />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}

                    <button type="button" onClick={() => removeGuide(index)} style={styles.removeGuideButton}>
                        ❌ Remove Guide
                    </button>
                </div>
            ))}

            {/* ✅ Buttons */}
            <div style={{ display: "flex", justifyContent: "start", gap: "10px", marginTop: "20px" }}>
                <button type="button" onClick={addGuide} style={styles.addButton}>
                    ➕ Add More Guides
                </button>
                <button type="submit" style={styles.submitButton}>
                    ✅ Submit Now
                </button>
            </div>
        </form>
    );
};

// 🔥 Styles for Layout
const styles = {
    card: {
        background: "#fff",
        padding: "20px",
        marginBottom: "20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: "15px",
        marginTop: "20px",
    },
    imageWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        background: "#f9f9f9",
        position: "relative",
    },
    thumbnail: {
        width: "100%",
        height: "auto",
        aspectRatio: "4/3",
        objectFit: "cover",
        borderRadius: "5px",
    },
    addButton: {
        padding: "10px 15px",
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    submitButton: {
        padding: "10px 15px",
        background: "#28a745",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    deleteButton: {
        marginTop: "5px",
        padding: "5px 10px",
        background: "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    removeGuideButton: {
        marginTop: "10px",
        padding: "8px 12px",
        background: "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
};

export default AddLocalGuide;

export const SuggestedItinerary = ({ location, onSubmit }) => {
    const [selectedSeason, setSelectedSeason] = useState("Summer");
    const [formData, setFormData] = useState({
        suggestedItinerary: {
            Summer: [],
            Winter: [],
            Monsoon: [],
        },
    });

    const staticBreakpoints = ["Start Journey", "Trekking Itinerary", "Descent", "Return Journey"];

    // ✅ Load existing itinerary data from location
    useEffect(() => {
        if (location && location.suggestedItinerary) {
            setFormData({
                suggestedItinerary: {
                    Summer: location.suggestedItinerary.Summer || [],
                    Winter: location.suggestedItinerary.Winter || [],
                    Monsoon: location.suggestedItinerary.Monsoon || [],
                },
            });
        }
    }, [location]);

    const addLocation = () => {
        setFormData((prev) => {
            return {
                suggestedItinerary: {
                    ...prev.suggestedItinerary,
                    [selectedSeason]: [
                        ...prev.suggestedItinerary[selectedSeason], // ✅ Create a new array (immutability fix)
                        {
                            name: "",
                            breakpoints: [
                                { title: "Start Journey", details: [{ time: "", title: "", description: "" }] },
                                { title: "Trekking Itinerary", details: [{ time: "", title: "", description: "" }] },
                                { title: "Descent", details: [{ time: "", title: "", description: "" }] },
                                { title: "Return Journey", details: [{ time: "", title: "", description: "" }] }
                            ]
                        }
                    ]
                }
            };
        });
    };


    // ✅ Remove a location
    const removeLocation = (locationIndex) => {
        setFormData((prev) => {
            const updatedItinerary = { ...prev.suggestedItinerary };
            updatedItinerary[selectedSeason].splice(locationIndex, 1);
            return { suggestedItinerary: updatedItinerary };
        });
    };

    // ✅ Handle location name change
    const handleLocationNameChange = (locationIndex, value) => {
        setFormData((prev) => {
            const updatedItinerary = { ...prev.suggestedItinerary };
            updatedItinerary[selectedSeason][locationIndex].name = value;
            return { suggestedItinerary: updatedItinerary };
        });
    };

    const addDetailRow = (locationIndex, breakpointIndex) => {
        setFormData((prev) => {
            const updatedItinerary = { ...prev.suggestedItinerary };
            updatedItinerary[selectedSeason] = updatedItinerary[selectedSeason].map((location, i) =>
                i === locationIndex
                    ? {
                        ...location,
                        breakpoints: location.breakpoints.map((breakpoint, j) =>
                            j === breakpointIndex
                                ? {
                                    ...breakpoint,
                                    details: [...breakpoint.details, { time: "", title: "", description: "" }]
                                }
                                : breakpoint
                        )
                    }
                    : location
            );
            return { suggestedItinerary: updatedItinerary };
        });
    };


    const removeDetailRow = (locationIndex, breakpointIndex, detailIndex) => {
        setFormData((prev) => {
            const updatedItinerary = { ...prev.suggestedItinerary };
            updatedItinerary[selectedSeason] = updatedItinerary[selectedSeason].map((location, i) =>
                i === locationIndex
                    ? {
                        ...location,
                        breakpoints: location.breakpoints.map((breakpoint, j) =>
                            j === breakpointIndex
                                ? {
                                    ...breakpoint,
                                    details: breakpoint.details.filter((_, k) => k !== detailIndex)
                                }
                                : breakpoint
                        )
                    }
                    : location
            );
            return { suggestedItinerary: updatedItinerary };
        });
    };


    // ✅ Handle change in a detail row
    const handleDetailChange = (locationIndex, breakpointIndex, detailIndex, field, value) => {
        setFormData((prev) => {
            const updatedItinerary = { ...prev.suggestedItinerary };
            updatedItinerary[selectedSeason][locationIndex].breakpoints[breakpointIndex].details[detailIndex][field] = value;
            return { suggestedItinerary: updatedItinerary };
        });
    };

    // ✅ Submit function
    const handleSubmit = () => {
        if (onSubmit) {
            console.log("Submitting form data:", formData.suggestedItinerary);
            onSubmit({ suggestedItinerary: formData.suggestedItinerary });
        }
    };

    return (
        <div style={{ padding: "15px" }}>
            <h3>Suggested Itinerary</h3>

            {/* Tabs for Seasons */}
            <div className="tabs">
                {["Summer", "Winter", "Monsoon"].map((season) => (
                    <button
                        key={season}
                        type="button"
                        className={`tabButton ${selectedSeason === season ? "btn-blue" : "btn-white"}`}
                        onClick={() => setSelectedSeason(season)}
                    >
                        {season}
                    </button>
                ))}
            </div>
            <hr />

            <form>
                <div>
                    <h4>{selectedSeason} Locations</h4>
                    <button type="button" onClick={addLocation} style={{ marginBottom: "10px" }}>
                        Add Location
                    </button>

                    {formData.suggestedItinerary[selectedSeason]?.map((location, locationIndex) => (
                        <div key={locationIndex} className="location-container">
                            <legend className="location-legend">
                                {location.name || `Location ${locationIndex + 1}`}
                            </legend>


                            {/* Location Name Input */}
                            <div className="row">
                                <div className="inputWrapper col-6 p-2">
                                    <label>Location Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter location name"
                                        value={location.name}
                                        onChange={(e) =>
                                            handleLocationNameChange(locationIndex, e.target.value)
                                        }
                                    />
                                </div>
                                <div className="inputWrapper col-3 p-2">
                                    <button
                                        type="button"
                                        onClick={() => removeLocation(locationIndex)}
                                        style={{ marginTop: "24px" }}
                                    >
                                        Remove Location
                                    </button>
                                </div>
                            </div>

                            {/* Static Breakpoints (Start Journey, Trekking Itinerary, Descent, Return Journey) */}
                            {location.breakpoints.map((breakpoint, breakpointIndex) => (
                                <div key={breakpointIndex} style={{ marginBottom: "15px" }}>
                                    <h5>{breakpoint.title}</h5>

                                    {breakpoint.details.map((detail, detailIndex) => (
                                        <div key={detailIndex} className="row" style={{ marginBottom: "10px" }}>
                                            <div className="inputWrapper col-3 p-2">
                                                <label>Time</label>
                                                <input
                                                    type="time"
                                                    value={detail.time}
                                                    onChange={(e) =>
                                                        handleDetailChange(locationIndex, breakpointIndex, detailIndex, "time", e.target.value)
                                                    }
                                                />
                                            </div>
                                            <div className="inputWrapper col-3 p-2">
                                                <label>Title</label>
                                                <input
                                                    type="text"
                                                    placeholder="Title"
                                                    value={detail.title}
                                                    onChange={(e) =>
                                                        handleDetailChange(locationIndex, breakpointIndex, detailIndex, "title", e.target.value)
                                                    }
                                                />
                                            </div>
                                            <div className="inputWrapper col-3 p-2">
                                                <label>Description</label>
                                                <input
                                                    type="text"
                                                    placeholder="Description"
                                                    value={detail.description}
                                                    onChange={(e) =>
                                                        handleDetailChange(locationIndex, breakpointIndex, detailIndex, "description", e.target.value)
                                                    }
                                                />
                                            </div>
                                            <div className="inputWrapper col-3 p-2">
                                                <button type="button" onClick={() =>
                                                    removeDetailRow(locationIndex, breakpointIndex, detailIndex)} style={{ marginTop: "24px" }}>
                                                    Remove Row
                                                </button>
                                            </div>
                                        </div>
                                    ))}

                                    {/* Add Row Button Inside Breakpoint */}
                                    <button type="button" onClick={() => addDetailRow(locationIndex, breakpointIndex)} style={{ marginBottom: "10px" }}>
                                        Add Row
                                    </button>
                                    <hr />
                                </div>
                            ))}

                            <hr style={{ backgroundColor: "red" }} />
                        </div>

                    ))}
                </div>
            </form >

            {/* Submit Button */}
            < button type="button" onClick={handleSubmit} className="btn-blue" >
                Submit
            </button >
        </div >
    );
};

export const GradeWiseInsights = ({ location, onSubmit }) => {
    const [selectedGrade, setSelectedGrade] = useState("Easy");
    const [formData, setFormData] = useState({
        gradeWiseInsights: {
            Easy: [],
            Moderative: [],
            Difficult: [],
        },
    });

    // Initialize form data when location data is passed
    React.useEffect(() => {
        if (location && location.gradeWiseInsights) {
            setFormData({
                gradeWiseInsights: {
                    Easy: location.gradeWiseInsights.Easy || [],
                    Moderative: location.gradeWiseInsights.Moderative || [],
                    Difficult: location.gradeWiseInsights.Difficult || [],
                },
            });
        }
    }, [location]);

    // Add a new route for the selected grade
    const addRoute = () => {
        setFormData((prevData) => {
            const updatedFormData = JSON.parse(JSON.stringify(prevData)); // Deep copy the form data
            updatedFormData.gradeWiseInsights[selectedGrade].push({
                base: "",
                route: "",
                description: "",
                duration: "",
                requiredEquipment: "",
                drinkingWater: [],
                food: [],
                accommodation: [],
                mobileNetwork: [],
                weather: [],
                commonNote: "",
            });
            return updatedFormData;
        });
    };


    // Remove a route for the selected grade
    const removeRoute = (routeIndex) => {
        setFormData((prevData) => {
            const updatedFormData = JSON.parse(JSON.stringify(prevData)); // Deep copy the form data
            updatedFormData.gradeWiseInsights[selectedGrade].splice(routeIndex, 1);
            return updatedFormData;
        });
    };


    // Update a route field
    const handleRouteChange = (routeIndex, field, value) => {
        setFormData((prevData) => {
            const updatedFormData = JSON.parse(JSON.stringify(prevData)); // Deep copy

            // ✅ If the field is one of the toggle fields, ensure it is a boolean
            if (["drinkingWater", "food", "accommodation", "mobileNetwork", "weather"].includes(field)) {
                updatedFormData.gradeWiseInsights[selectedGrade][routeIndex][field] = Boolean(value);
            } else {
                updatedFormData.gradeWiseInsights[selectedGrade][routeIndex][field] = value;
            }

            return updatedFormData;
        });
    };


    // Add a sub-category item (e.g., Drinking Water)
    const addSubCategoryItem = (routeIndex, category) => {
        setFormData((prevData) => {
            const updatedFormData = JSON.parse(JSON.stringify(prevData)); // Deep copy the form data
            updatedFormData.gradeWiseInsights[selectedGrade][routeIndex][category].push({
                title: "",
                description: "",
                available: "No",
            });
            return updatedFormData;
        });
    };


    // Remove a sub-category item
    const removeSubCategoryItem = (routeIndex, category, itemIndex) => {
        setFormData((prevData) => {
            const updatedFormData = JSON.parse(JSON.stringify(prevData)); // Deep copy the form data
            const categoryItems = updatedFormData.gradeWiseInsights[selectedGrade][routeIndex][category];
            if (categoryItems && categoryItems.length > 0 && categoryItems[itemIndex]) {
                categoryItems.splice(itemIndex, 1);
            }
            return updatedFormData;
        });
    };



    // Update a sub-category item
    const handleSubCategoryChange = (routeIndex, category, itemIndex, field, value) => {
        setFormData((prevData) => {
            const gradeRoutes = prevData.gradeWiseInsights?.[selectedGrade] || [];

            return {
                ...prevData,
                gradeWiseInsights: {
                    ...prevData.gradeWiseInsights,
                    [selectedGrade]: gradeRoutes.map((route, currentRouteIndex) => {
                        if (currentRouteIndex !== routeIndex) {
                            return route;
                        }

                        const categoryItems = route[category] || [];

                        return {
                            ...route,
                            [category]: categoryItems.map((item, currentItemIndex) => {
                                if (currentItemIndex !== itemIndex) {
                                    return item;
                                }

                                return {
                                    ...item,
                                    [field]: value,
                                };
                            }),
                        };
                    }),
                },
            };
        });
    };

    // Handle form submission
    const handleSubmit = () => {
        if (onSubmit) {
            onSubmit({ gradeWiseInsights: formData.gradeWiseInsights });
        }
    };

    return (
        <div style={{ padding: "15px" }}>
            <h3>Grade-Wise Insights</h3>
            {/* Tabs for Grades */}
            <div className="tabs">
                {["Easy", "Moderative", "Difficult"].map((grade) => (
                    <button
                        key={grade}
                        type="button"
                        className={`tabButton ${selectedGrade === grade ? "btn-blue" : "btn-white"}`}
                        onClick={() => setSelectedGrade(grade)}
                    >
                        {grade}
                    </button>
                ))}
            </div>
            <hr />

            {/* Form Content */}
            <form>
                <div>
                    <h4>{selectedGrade} Routes</h4>
                    <button
                        type="button"
                        onClick={addRoute}
                        className="btn-white"
                    >
                        Add Route
                    </button>
                    {formData.gradeWiseInsights[selectedGrade]?.map((route, routeIndex) => (
                        <div key={routeIndex} style={{ marginBottom: "20px" }}>
                            <div className="row">
                                <div className="inputWrapper col-3 p-2">
                                    <label>Base</label>
                                    <input
                                        type="text"
                                        placeholder="Base"
                                        value={route.base}
                                        onChange={(e) =>
                                            handleRouteChange(routeIndex, "base", e.target.value)
                                        }
                                    />
                                </div>
                                <div className="inputWrapper col-3 p-2">
                                    <label>Route</label>
                                    <input
                                        type="text"
                                        placeholder="Route"
                                        value={route.route}
                                        onChange={(e) =>
                                            handleRouteChange(routeIndex, "route", e.target.value)
                                        }
                                    />
                                </div>
                                <div className="inputWrapper col-3 p-2">
                                    <label>Description</label>
                                    <input
                                        type="text"
                                        placeholder="Description"
                                        value={route.description}
                                        onChange={(e) =>
                                            handleRouteChange(
                                                routeIndex,
                                                "description",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="inputWrapper col-3 p-2">
                                    <label>Duration</label>
                                    <input
                                        type="text"
                                        placeholder="Duration"
                                        value={route.duration}
                                        onChange={(e) =>
                                            handleRouteChange(routeIndex, "duration", e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="inputWrapper col-3 p-2">
                                    <label>Required Equipment</label>
                                    <input
                                        type="text"
                                        placeholder="Required Equipment"
                                        value={route.requiredEquipment}
                                        onChange={(e) =>
                                            handleRouteChange(
                                                routeIndex,
                                                "requiredEquipment",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="inputWrapper col-3 p-2">
                                    <label>Common Note</label>
                                    <textarea
                                        placeholder="Common Note"
                                        value={route.commonNote}
                                        onChange={(e) =>
                                            handleRouteChange(routeIndex, "commonNote", e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                            <div className="row custom-grid">
                                {["drinkingWater", "food", "accommodation", "mobileNetwork", "weather"].map((category) => (
                                    <div key={category} className="custom-grid-item p-2">
                                        <h5>{category.replace(/([A-Z])/g, " $1")}</h5>

                                        <button type="button" onClick={() => addSubCategoryItem(routeIndex, category)}>
                                            Add {category}
                                        </button>

                                        {route[category]?.map((item, itemIndex) => (
                                            <div key={itemIndex} className="custom-input-container grade-insight-row">
                                                <input
                                                    type="text"
                                                    placeholder="Title"
                                                    value={item.title}
                                                    onChange={(e) =>
                                                        handleSubCategoryChange(routeIndex, category, itemIndex, "title", e.target.value)
                                                    }
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Description"
                                                    value={item.description}
                                                    onChange={(e) =>
                                                        handleSubCategoryChange(routeIndex, category, itemIndex, "description", e.target.value)
                                                    }
                                                />

                                                <div className="grade-availability-toggle" aria-label="Availability">
                                                    {["Yes", "No"].map((value) => (
                                                        <button
                                                            key={value}
                                                            type="button"
                                                            className={(item.available || "No") === value ? "is-active" : ""}
                                                            onClick={() =>
                                                                handleSubCategoryChange(
                                                                    routeIndex,
                                                                    category,
                                                                    itemIndex,
                                                                    "available",
                                                                    value
                                                                )
                                                            }
                                                        >
                                                            {value}
                                                        </button>
                                                    ))}
                                                </div>

                                                <button type="button" onClick={() => removeSubCategoryItem(routeIndex, category, itemIndex)}>
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>



                            <button
                                type="button"
                                onClick={() => removeRoute(routeIndex)}
                                className="deleteButton"
                            >
                                Remove Route
                            </button>
                            <hr />
                        </div>

                    ))}
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="btn-blue"
                    >
                        Submit
                    </button>
                </div>
            </form >
        </div >
    );
};
